import React, { useState, useEffect, useContext } from "react";
// import TruckDetail from "./../woodchip/modaltruckDetail";
// import { getCarDetail } from "./../../services/wms";

import BranchContext from "./../context/branch";
const Reporttable = ({ list, header ,handelClick }) => {
  // const [isOpen, setisOpen] = useState(false);

  const { currentBranch } = useContext(BranchContext);

  // const [carDetials, setcarDetials] = useState([]);
  // const [statusid, setstatusid] = useState(0);
  // const [branchID, setbranchID] = useState(0);
  // const [carID, setcarID] = useState(0);

  // useEffect(() => {
  //   if (!currentBranch) return;

  //   if (carID == 0) return;
  //   if (statusid == 0) return;
  //   if (branchID == 0) return;

  //   const getdata = async () => {
  //     const { data: result } = await getCarDetail(branchID, statusid, carID);

  //     if (result.status === "success") {
  //       setcarDetials(result.data.list);
  //     }
  //   };
  //   getdata();
  // }, [currentBranch, branchID, statusid, carID]);

  // const handelClick = (event, branchid, statusid) => {
  //   setbranchID(branchid);
  //   setstatusid(statusid);
  //   setcarID(event);
  //   setisOpen(true);
  // };
  // const handleClose = () => {
  //   setisOpen(false);
  // };

  return (
    <div className="container-fluid">
      {/* <TruckDetail
        isOpen={isOpen}
        onCancel={handleClose}
        message="ข้อมูลรถ"
        list={carDetials}
      /> */}

      <table className="table responsive table-hover">
        <thead >
          <tr>
            <th scope="col">ลำดับ</th>
            {header &&
              header.length > 0 &&
              header.map((header) => (
                <th key={header.id} scope="col">
                  {" "}
                  {header.name}{" "}
                </th>
              ))}
          </tr>
        </thead>

        <tbody>
          {list &&
            list.length > 0 &&
            list.map((itemmain, index) => (
              <tr key={itemmain.id}>
                <th scope="row">
                  {itemmain.id == "999" ? null : (
                    <span className="badge rounded-pill bg-secondary me-1">
                      {itemmain.id}
                    </span>
                  )}

                  {itemmain.id == "999" ? (
                    "Total"
                  ) : (
                    <span className="">{itemmain.BranchName}</span>
                  )}
                </th>

                {itemmain.Cars.map((item, index) => (
                  <td key={item.CarID}>
                    {item.Total === 0 ? null : (
                      <>
                        <span
                          className="badge bg-primary me-2"
                          style={{ fontSize: "14px", cursor: "pointer" }}
                          onClick={() =>
                            handelClick(item.CarID, itemmain.branchID, 1)
                          }
                        >
                          {item.Total}
                        </span>

                        {item.Active == "0" ? null : (
                          <span
                            className="badge bg-success me-2"
                            style={{ fontSize: "14px", cursor: "pointer" }}
                            onClick={() =>
                              handelClick(item.CarID, itemmain.branchID, 2)
                            }
                          >
                            {item.Active}
                          </span>
                        )}

                        {item.Standby == 0 ? null : (
                          <span
                            className="badge bg-warning me-2"
                            style={{ fontSize: "14px", cursor: "pointer" }}
                            onClick={() =>
                              handelClick(item.CarID, itemmain.branchID, 3)
                            }
                          >
                            {item.Standby}
                          </span>
                        )}

                        {item.noActive == 0 ? null : (
                          <span
                            className="badge bg-danger me-2"
                            style={{ fontSize: "14px", cursor: "pointer" }}
                            onClick={() =>
                              handelClick(item.CarID, itemmain.branchID, 4)
                            }
                          >
                            {item.noActive}
                          </span>
                        )}
                      </>
                    )}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Reporttable;
